import React from 'react'
import I18n from 'i18n'
import useMaterializeTextField from 'components/hooks/MaterializeTextField'
import { LOCALES, supportedLocales } from 'components/common/Locales'
import type { InvitationTexts } from 'components/common/types/GroupProtocolSubscription'

export interface InvitationTextConfigurationProps {
  maxInvitationLength: number
  invitationTexts: InvitationTexts
  onChange: (locale: string, text: string) => void
}

const MAX_INVITATION_LENGTH = 140
const InvitationTextConfiguration: React.FC<InvitationTextConfigurationProps> = ({
  onChange,
  maxInvitationLength = MAX_INVITATION_LENGTH,
  invitationTexts
}): React.ReactElement => {
  useMaterializeTextField()
  return (
    <>
      <div className='row'>
        {supportedLocales.map(locale => (
          <div key={locale} className='col s12 input-field'>
            <input id={`invitation-text-${locale}`} maxLength={maxInvitationLength} type='text' className='validate' value={invitationTexts[locale] ?? ''} onChange={(e) => onChange(locale, e.target.value)} />
            <label htmlFor={`invitation-text-${locale}`}>{I18n.t('group.detail.questionnaires.invitation_text', { language: LOCALES[locale].name })}</label>
          </div>
        ))}
      </div>
    </>
  )
}

export default InvitationTextConfiguration
